import React, { useMemo } from "react";
import moment from "moment";

import LiveButton from "./LiveButton";
import ScheduleButton from "./ScheduleButton";

const ClientPanel = ({
  status,
  setStatus,
  campaignId,
  orgaId,
  userName,
  userProfile,
  orgaName,
  campaignManager,
  setShowStartingDatePanel,
  startDate,
  source,
  jobUpdatesUrl,
  duration,
  adsetId,
  flags,
  organization
}) => {
  const campaignWasScheduled = useMemo(
    () => (startDate ? moment() < moment(startDate) : false),
    [startDate]
  );

  if (status == "SCHEDULED") {
    return <></>;
  }

  return campaignWasScheduled ? (
    <ScheduleButton
      status={status}
      setStatus={setStatus}
      campaignId={campaignId}
      userName={userName}
      startDate={startDate}
      duration={duration}
      userProfile={userProfile}
      setShowStartingDatePanel={setShowStartingDatePanel}
    />
  ) : (
    <LiveButton
      status={status}
      setStatus={setStatus}
      campaignId={campaignId}
      orgaId={orgaId}
      userName={userProfile?.userName}
      userId={userProfile?.id}
      userProfile={userProfile || {}}
      orgaName={orgaName}
      campaignManager={campaignManager}
      setShowStartingDatePanel={setShowStartingDatePanel}
      startDate={startDate}
      source={source}
      jobUpdatesUrl={jobUpdatesUrl}
      duration={duration}
      adsetId={adsetId}
      flags={flags}
      organization={organization}
    />
  );
};

export default ClientPanel;
